"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var styled_components_1 = tslib_1.__importStar(require("styled-components"));

var isInverseStyles = (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  background: ", ";\n  border-bottom: 0.0625rem solid\n    ", ";\n"], ["\n  background: ", ";\n  border-bottom: 0.0625rem solid\n    ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.DARK', theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["700"]', theme);
});
exports.Root = styled_components_1.default.header(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  gap: 1.5rem;\n  width: 100%;\n  height: 4rem;\n  background: ", ";\n  border-bottom: 0.0625rem solid\n    ", ";\n  ", ";\n\n  @media (max-width: 35rem) {\n    height: 3.5rem;\n    gap: 1rem;\n  }\n"], ["\n  display: flex;\n  justify-content: space-between;\n  gap: 1.5rem;\n  width: 100%;\n  height: 4rem;\n  background: ", ";\n  border-bottom: 0.0625rem solid\n    ", ";\n  ", ";\n\n  @media (max-width: 35rem) {\n    height: 3.5rem;\n    gap: 1rem;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.WHITE', theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.LIGHT', theme);
}, function (props) {
  return props.isInverse && isInverseStyles;
});
var templateObject_1, templateObject_2;